<ui-confirmation-dialog
    #integrationConfirmationDialog
    header="applicant-tracker.removeFromJobBoardDialog.{{
        activeIntegrationObject?.atsJobIntegration.isEnabled ? 'header' : 'removeToJobBoardJobTitle'
    }}"
    size="small"
    [primaryButtonLabel]="activeIntegrationObject?.atsJobIntegration.isEnabled ? 'add' : 'remove'"
>
    <p
        [innerHTML]="
            (activeIntegrationObject?.atsJobIntegration.isEnabled
                ? 'applicant-tracker.removeFromJobBoardDialog.add'
                : 'applicant-tracker.removeFromJobBoardDialog.remove'
            )
                | translate
                    : {
                          integrationText:
                              activeIntegrationObject?.atsJobIntegration.integrationType.integrationType.name,
                      }
                | sanitizeHtml
        "
    ></p>
</ui-confirmation-dialog>

<ui-confirmation-dialog
    #unableToSponsorDialog
    [header]="'applicant-tracker.unableToSponsorJob'"
    size="small"
    [primaryButtonLabel]="'okay'"
>
    <p [innerHTML]="'applicant-tracker.messages.jobPosting.indeedPaymentDetailsAreMissing' | translate"></p>
</ui-confirmation-dialog>

<ui-confirmation-dialog
    #indeedValidationDialog
    [header]="'applicant-tracker.unableToPostToIndeedDialog.header'"
    size="small"
    [primaryButtonLabel]="'applicant-tracker.okay'"
>
    <p>{{ 'applicant-tracker.unableToPostToIndeedDialog.errorMessageInfo' | translate }}</p>

    <ul *ngFor="let violation of indeedValidationMessages">
        <li>{{ violation.field }}: {{ violation.message }}</li>
    </ul>

    <p>{{ 'applicant-tracker.unableToPostToIndeedDialog.tryAgain' | translate }}</p>
</ui-confirmation-dialog>

<ui-card class="loadable" [class.loading]="isLoading">
    <app-segment-header [title]="'applicant-tracker.jobBoardIntegrationsTitle'">
        @if (shouldShowExploreIntegrations) {
            <div class="buttons">
                <ui-button type="link" [routerLink]="['/', 'settings', 'integrations-v2']">
                    {{ 'applicant-tracker.exploreIntegrations' | translate }}
                </ui-button>
            </div>
        }
    </app-segment-header>
    <div *ngIf="jobPosting.isPaused || jobPosting.isArchived">
        <app-empty-state
            label="applicant-tracker.emptyStateJobPosting"
            src="/assets/illustrations/briefcase.png"
        ></app-empty-state>
    </div>

    <div
        *ngIf="!integrationObjects.length && !jobPosting.isPaused && !jobPosting.isArchived"
        class="flex col align-items-center justify-center"
    >
        <p class="text-align-center" [innerHTML]="'applicant-tracker.integrationsNotConnected' | translate"></p>
        <ui-button type="primary" [routerLink]="['/', 'settings', 'integrations-v2']">{{
            'applicant-tracker.connectIntegration' | translate
        }}</ui-button>
    </div>

    <div *ngIf="integrationObjects.length && !jobPosting.isPaused && !jobPosting.isArchived">
        <div class="app-grid integration-header">
            <div class="columns-4"></div>
            <div class="columns-8 text-align-center">{{ 'applicant-tracker.postingLink' | translate }}</div>
        </div>

        @for (integrationObject of integrationObjects; track integrationObject) {
            <div
                class="app-grid integration-item"
                [ngClass]="integrationObject.atsJobIntegration.integrationType.integrationType.name"
            >
                <div class="columns-4">
                    <div class="flex align-items-center">
                        <mat-slide-toggle
                            name="indeedToggle"
                            color="primary"
                            [(ngModel)]="integrationObject.atsJobIntegration.isEnabled"
                            (ngModelChange)="updateIntegration($event, integrationObject)"
                            [disabled]="integrationObject.meta.syncing || !!integrationObject.meta.disabled"
                        >
                            <div class="logo-container flex align-items-center">
                                <app-svg-image
                                    [url]="integrationObject.meta.logo"
                                    [attr.aria-label]="
                                        integrationObject.atsJobIntegration.integrationType.integrationType.name +
                                        '-logo'
                                    "
                                    class="integration-logo"
                                />
                            </div>
                            @if (integrationObject.meta.disabled) {
                                <div class="integration-unavailable">
                                    {{ 'temporarilyUnavailable' | translate }}
                                </div>
                            }
                        </mat-slide-toggle>

                        <ui-badge
                            class="margin-left-3"
                            *ngIf="integrationObject.meta.syncing && !integrationObject.meta.failed"
                            >{{ 'applicant-tracker.syncingPill' | translate }}</ui-badge
                        >

                        <ui-badge type="danger" class="margin-left-3" *ngIf="integrationObject.meta.failed">{{
                            'applicant-tracker.failedPill' | translate
                        }}</ui-badge>
                    </div>
                </div>
                <div class="columns-8 text-align-center open-link-column">
                    <ui-button
                        type="link"
                        [disabled]="!integrationObject.meta.publicUrl"
                        (click)="openLink(integrationObject.meta.publicUrl)"
                        ><mat-icon svgIcon="openInNew"></mat-icon> {{ 'applicant-tracker.openLink' | translate }}
                    </ui-button>
                </div>
            </div>
        }
    </div>
</ui-card>
